import { request } from "./http";
import { storage } from "./storage";

const extractToken = (res) => {
  const raw =
    res?.token ||
    res?.accessToken ||
    res?.data?.token ||
    res?.data?.accessToken ||
    res?.data?.data?.token ||
    res?.data?.data?.accessToken ||
    "";

  const token = String(raw || "").trim();
  return token.length ? token : null;
};

const extractAuthData = (res, fallbackEmail) => {
  // الأهم: إدخال res.data كحالة شائعة جدًا مع wrappers
  return (
    res?.authData ||
    res?.user ||
    res?.data?.authData ||
    res?.data?.user ||
    res?.data ||                 // ✅ مهم جدًا
    res?.data?.data?.authData ||
    res?.data?.data?.user ||
    res?.data?.data ||           // ✅ مفيد لو فيه data داخل data
    res ||
    { email: fallbackEmail }
  );
};

const getEmailFromFormData = (fd) => {
  try {
    if (fd?.get) return fd.get("Email") || fd.get("email") || null;
    return null;
  } catch {
    return null;
  }
};

export const authService = {
  async login(dto) {
    const res = await request("/Auth/login", {
      method: "POST",
      body: dto,
      auth: false,
    });

    const authData = extractAuthData(res, dto?.email);
    const token = extractToken(res);

    const allowedWithoutToken =
      authData?.needsPendingApproval === true ||
      authData?.hasErpAccess === false ||
      authData?.isLicenseExpired === true;

    if (!token && !allowedWithoutToken) {
      // ✅ مهم: متسيبيش authData مخزنة في الحالة دي
      storage.clear();
      throw new Error("Login succeeded but token is missing in response");
    }

    // ✅ خزّني بعد التأكد
    storage.setAuthData(authData);

    if (token) storage.setToken(token);
    else storage.clearToken?.();

    return authData;
  },

  async register(formData) {
    const res = await request("/Auth/register", {
      method: "POST",
      body: formData,
      auth: false,
    });

    const fallbackEmail = getEmailFromFormData(formData);
    const authData = extractAuthData(res, fallbackEmail);

    storage.setAuthData(authData);

    const token = extractToken(res);
    if (token) storage.setToken(token);
    else storage.clearToken?.();

    return res;
  },

  forgotPassword(dto) {
    return request("/Auth/forgot-password", {
      method: "POST",
      body: dto,
      auth: false,
    });
  },

  resetPassword(dto) {
    return request("/Auth/reset-password", {
      method: "POST",
      body: dto,
      auth: false,
    });
  },

  logout() {
    storage.clear();
  },
};
